import { SliderThumb } from './SliderThumb';

// TODO: in v9, move styled() from SliderThumb.jsx to here
export var StyledSliderThumb = SliderThumb;